import { RULES_SIDEBAR_OPEN_SETTING_SUFFIX } from '../rulesManagement.constant';

export const rulesSidebarOpenSettingKey = (settingsKey: string): string => `${settingsKey}${RULES_SIDEBAR_OPEN_SETTING_SUFFIX}`;
